export default "__VITE_ASSET__895cae26__"